class ReactFilterLocationRadius extends React.Component{
    
    constructor(props) {
        super(props);

        this.state = {
            isActive: false,
            isExpanded: false,
            location: props.settings.location,
            latitude: props.settings.latitude,
            longitude: props.settings.longitude,
            radius: props.settings.radius || 50,
            errorMessage: null
        };
    }
 
    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */

    getValues() {
        this.setState({isActive: !!this.state.location});
        return {
            location: this.state.location,
            latitude: this.state.latitude,
            longitude: this.state.longitude,
            radius: this.state.radius
        };
    }
    
    initAutocomplete(){
        var me = this;

        this.autocomplete = new google.maps.places.Autocomplete(me.refs.location);

        google.maps.event.addDomListener(
            me.autocomplete,
            'place_changed',
            function(){
                var place = me.autocomplete.getPlace();

                var latitude = null;
                var longitude = null;
                var decimalMaxLength = Math.pow(10, 16); // the max number of decimals = 16

                if (place.geometry) {
                    latitude = Math.round(place.geometry.location.lat() * decimalMaxLength) / decimalMaxLength;
                    longitude = Math.round(place.geometry.location.lng() * decimalMaxLength) / decimalMaxLength;
                }
                me.onLocationChange(latitude, longitude, me.refs.location.value);
            }
        );
    }
    
    componentDidMount(){
        var me = this,
            apiKey = this.props.settings.apiKey?this.props.settings.apiKey:null;

        if(apiKey){

            // Check if already loaded
            if(typeof google != 'undefined' && google.maps && google.maps.places) {
                me.initAutocomplete();
            } else {
                // Use "gm_authFailure" function to show Google Maps error, since try/catch didn't work
                window.gm_authFailure = function() {
                    me.setState({
                        errorMessage: 'GoogleMaps Auth Failure: Possibly wrong Api Key used'
                    });
                };

                jQuery.getScript('https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places').done(function () {
                    me.initAutocomplete();
                });
            }

        } else {
            this.setState({
                errorMessage: '"Google Maps Javascript Api Key" was not saved in module settings'
            });
        }
    }
    
    onRadiusChange(event){
        this.setState({radius: event.target.value});
    }
    
    onLocationChange(latitude,longitude,location){
        this.setState({
            location:location,
            latitude:latitude,
            longitude:longitude
        })
    }

    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.setState({
            isActive: false,
            location:null,
            latitude:null,
            longitude:null,
            radius:50
        })
    }

    /**
     * Called by the grid, should set valuies
     * @returns Object
     */
    setValues(values) {
        if(values.location){
            this.setState({
                isActive:true,
                location:values.location,
                latitude:values.latitude?values.latitude:null,
                longitude:values.longitude?values.longitude:null,
                radius:values.radius?values.radius:this.state.radius
            });
        }else{
            this.clearValues();
        }        
    }

    clearFilter() {
        this.clearValues();
        if(this.props.loadGrid) {
            setTimeout( function(){
                this.props.loadGrid();
            }.bind(this), 50);
        }
    }

    togglePopup() {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    /**
     * Called by "OutsideClick" Mixin to handle outside click
     */
    outsideClickHandle(e) {
        this.setState({
            isExpanded: false
        });
    }

    handleFilterButtons(event) {
        this.setState({
            isExpanded: false
        });

        if(event.target.dataset.button == "apply"){
            this.props.applyFilters();
        }
        if(event.target.dataset.button == "clear"){
            this.props.clearFilters();
        }
    }

    getRanges(){
        var ranges = [5,10,15,25,50,75,100,125,150,175,200,250];
        var values = [];
        ranges.forEach(function(value){
            values.push(<option key={value} value={value}>{value+' miles'}</option>)
        })
        return values;
    }
    
    onLocationChangeFn(event){
        this.setState({location: event.target.value});
    }
    
    onKeyUp(event) {
        if (event.which == 13) { // search on ENTER
            if(this.props.loadGrid) {
                this.props.loadGrid();
            }
        }
    }
    
    render() {
        var props = this.props;
        var state = this.state;

        var holderCls = 'btn-group custom-dropdown-wrapper location-radius-filter-wrapper';
        if(this.state.isActive){
            holderCls += ' active';
        }
        if(this.state.isExpanded){
            holderCls += ' expanded';
        }
        if(this.state.errorMessage){
            holderCls += ' has-error';
        }

        var buttons = null;
        if(this.props.applyFilters && this.props.clearFilters){
            buttons = (
                <div className="grid-filter-actions">
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="apply" className="btn btn-primary apply-filter" role="button">Apply</a>
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="clear" className="btn btn-link clear-filter" role="button">Reset</a>
                </div>
            );
        }

        return (
            <div className={holderCls}>
                <div className="custom-dropdown-button">
                    <button type="button" className="btn btn-primary dropdown-toggle custom-dropdown-toggle" ref="outside_click_trigger" onClick={this.togglePopup.bind(this)} data-toggle="custom-dropdown" aria-haspopup="true" aria-expanded="false">
                        { this.props.label }
                    </button>
                </div>
                <div className="custom-dropdown-clear-button">
                    <button type="button" className="btn btn-primary clear-filter" onClick={this.clearFilter.bind(this)}><i/></button>
                </div>
                <div className="card custom-dropdown-popup" ref="outside_click_content">
                    <div className="card-block">
                        <div className="content">
                            <div className="field-holder">
                                <input ref="location" type="text" placeholder={props.label} value={state.location} onChange={this.onLocationChangeFn.bind(this)} onKeyUp={this.onKeyUp.bind(this)}/>
                            </div>
                            <div className="field-holder">
                                <select ref="radius" value={state.radius} onChange={this.onRadiusChange.bind(this)}>
                                    {this.getRanges()}
                                </select>
                            </div>
                            {this.state.errorMessage ?
                                <div className="help-block help-block-error">{this.state.errorMessage}</div>
                                : undefined}
                            {buttons}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReactFilterLocationRadius.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.object,
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
}